import template from './day-overrides.html';
import controller from './day-overrides.controller';

const DayOverridesComponent = {
  template,
  controller,
  bindings: {
    weekDayConfig: '<',
    dayOverrides: '<',
    onChange: '&',
  },
};

export default DayOverridesComponent;



// WEBPACK FOOTER //
// ../widgets/day-overrides/day-overrides.component.js